import React from 'react'
import { InformationContent } from './PropertyPanelInformationTab.styles'

export interface PropertyPanelInformationTabProps {
  children: React.ReactNode
}

export const PropertyPanelInformationTab: React.FC<
  PropertyPanelInformationTabProps
> = ({ children }) => {
  return <InformationContent>{children}</InformationContent>
}
